// QtyStepper — part of the product option modal (ProductOptionView).
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

// Styling lives in the stylesheet (.po-stepper) so it can follow the merchant
// theme; previously these were inline literals that no theme could reach.
export default function QtyStepper({
  value,
  min = 0,
  max = 0,
  disableIncrement = false,
  onChange,
  label,
}) {
  const atMax = max > 0 && value >= max;
  const incrementLocked = atMax || disableIncrement;
  return (
    <div className="po-stepper">
      <button
        type="button"
        className="po-stepper-btn"
        aria-label={label ? `${label}: decrease` : 'Decrease quantity'}
        onClick={(event) => {
          event.stopPropagation();
          onChange(Math.max(min, value - 1));
        }}
        disabled={value <= min}
      >
        <MinusOutlined />
      </button>
      <span className="po-stepper-value">{value}</span>
      <button
        type="button"
        className="po-stepper-btn"
        aria-label={label ? `${label}: increase` : 'Increase quantity'}
        onClick={(event) => {
          event.stopPropagation();
          onChange(max > 0 ? Math.min(max, value + 1) : value + 1);
        }}
        disabled={incrementLocked}
      >
        <PlusOutlined />
      </button>
    </div>
  );
}
